
<template>
    <nav class="left-nav" aria-label="Side Navigation">
        <div class="d-md-none">
            <!-- Begin: Mobile "left nav" -->
            <aha-listbox 
                dropdown-tag="div" 
                role="navigation" 
                :default-value="findActiveItem()" 
                toggle-class="btn btn-outline btn--select w-100">
                <template slot="dropdown" v-for="(mLink, mIndex) in menuData">
                    <template v-if="!mLink.active">
                        <aha-select-dropdown-item 
                            :key="mIndex" 
                            :href="mLink.url" 
                            tag="a" 
                            role="" 
                            :text="mLink.text" 
                            :target="mLink.target" 
                            item-class="c-select-dropdown__item">{{ mLink.text }}</aha-select-dropdown-item>
                    </template>

                    <template v-else>
                        <aha-select-dropdown-item 
                            :key="mIndex" 
                            tag="span" 
                            :text="mLink.text" 
                            item-class="c-select-dropdown__item selected" 
                            selected>{{ mLink.text }}</aha-select-dropdown-item>
                    </template>
                </template>
            </aha-listbox>
            <!-- End:   Mobile "left nav" -->
        </div>

        <div class="d-none d-md-block">
            <!-- Begin: Tablet+ "left-nav" -->
            <template v-for="(link, index) in menuData">
                <template v-if="!link.active">
                    <a :key="index" 
                        :href="link.url" 
                        v-html="link.text" 
                        :target="link.target"
                        class="left-nav__item"></a>
                </template>

                <template v-else>
                    <span :key="index" 
                        v-html="link.text" 
                        class="left-nav__item is-active"></span>
                </template>
            </template>
            <!-- End:   Tablet+ "left-nav" -->
        </div>
    </nav>
</template>

<script>
    export default {
        props: {
            scData: {
                // example data can be found:
                // demo\components\phd\phd-left-nav-demo.vue
                type: Array,
                required: true
            }
        },
        data() {
            return {
                menuData: {}
            }
        },
        beforeMount() {
            this.menuData = this.scData;
        },
        methods: {
            findActiveItem() {                
                let activeText = "Menu";

                for(let i = 0; i < this.menuData.length; i++ ) {
                    let thisItem = this.menuData[i];
                    if(thisItem.active) {
                        activeText = thisItem.text;
                        break;
                    }
                }
                
                return activeText;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/phd/left-nav.vue